module.exports = __webpack_public_path__ + "img/logoESGEnterprises.fb8a25ef.png";